import $$ from 'cmn-utils';

//日程审核消息
export async function qryMessagesOfSchedule(payload) {
	return $$.post('/message/qryMessagesOfSchedule', payload);
}

//日程审核消息总数
export async function qryMessagesCountOfSchedule(payload) {
	return $$.post('/message/qryMessagesCountOfSchedule', payload);
}





// WEBPACK FOOTER //
// ./src/routes/NavBar/AuditNotice/service/index.js